import { render } from "./AdminSidebar.vue?vue&type=template&id=d9a81848&scoped=true"
import script from "./AdminSidebar.vue?vue&type=script&lang=js"
export * from "./AdminSidebar.vue?vue&type=script&lang=js"

import "./AdminSidebar.vue?vue&type=style&index=0&id=d9a81848&lang=scss"
import "./AdminSidebar.vue?vue&type=style&index=1&id=d9a81848&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9a81848"]])

export default __exports__